var _ellipse, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinErrorActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 45,
    viewBox: "0 0 29 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5,
    cy: 41.6406,
    rx: 10.6333,
    ry: 2.5625,
    fill: "url(#paint0_radial_1304_281643)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.35C29 6.355 22.5786 0 14.5 0C6.42143 0 0 6.355 0 14.35C0 25.01 14.5 41 14.5 41C14.5 41 29 25.01 29 14.35Z",
    fill: "#CA3C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1C22.0361 1 28 6.91706 28 14.35C28 16.8094 27.1575 19.6564 25.8236 22.5983C24.496 25.5263 22.7169 28.4727 20.9231 31.1101C19.1313 33.7447 17.3375 36.0527 15.9909 37.7027C15.391 38.4378 14.8807 39.0412 14.5 39.4835C14.1193 39.0412 13.609 38.4378 13.0091 37.7027C11.6625 36.0527 9.86867 33.7447 8.07688 31.1101C6.28312 28.4727 4.50396 25.5263 3.17638 22.5983C1.84248 19.6564 1 16.8094 1 14.35C1 6.91706 6.96388 1 14.5 1Z",
    stroke: "#424E54",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0444 14.0938C18.0444 12.127 16.9876 10.4806 15.1444 10.045V9.60938C15.1444 9.07766 14.7127 8.64844 14.1778 8.64844C13.6429 8.64844 13.2111 9.07766 13.2111 9.60938V10.045C11.3616 10.4806 10.3111 12.1206 10.3111 14.0938V17.2969L9.02222 18.5781V19.2188H19.3333V18.5781L18.0444 17.2969V14.0938ZM10.4078 8.74453L11.3293 9.66062C10.0147 10.5895 9.13822 12.0758 9.04155 13.7734H7.75266C7.84288 11.7234 8.86111 9.91688 10.4078 8.74453ZM20.6029 13.7734H19.314C19.2173 12.0758 18.3344 10.5895 17.0327 9.66062L17.9478 8.74453C19.488 9.91688 20.5062 11.7234 20.6029 13.7734ZM14.4356 21.115C14.3518 21.1342 14.268 21.1406 14.1778 21.1406C13.4624 21.1406 12.8889 20.5641 12.8824 19.8594H15.4602C15.4602 20.0388 15.428 20.2053 15.3636 20.3591C15.196 20.7434 14.8544 21.0253 14.4356 21.115Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1304_281643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5 41.6406) rotate(90) scale(2.5625 10.6333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424E54",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424E54",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinErrorActive);
export default __webpack_public_path__ + "static/media/Pin_Error_Active.f69025fe3955618b4f6264f788bf921d.svg";
export { ForwardRef as ReactComponent };